<div class="dataset-details">
  <table class="table table-sm table-borderless align-top">
    <thead>
      <tr>
        <th scope="col">Name</th>
        <th scope="col">Size</th>
        @if (showDate) {
          <th scope="col">Date</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (dataset of datasets; track dataset.datasetId) {
        <tr>
          <td class="">{{ dataset.name }}</td>
          <td class="text-muted">{{ dataset.size | bytes: 0 }}</td>
          @if (showDate) {
            <td class="text-muted">{{ dataset.created | localDate }}</td>
          }
          <td>
            @for (label of labelsFor(dataset); track label.labelId) {
              <ch-label-pill [label]="label"></ch-label-pill>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
